module.exports = __webpack_public_path__ + "img/notFoundIllustration.1da63921.svg";